export default __webpack_public_path__ + "b1403daaeb2db2d7f997b77cc89e13a8.png";